import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=e384f1be&scoped=true"
import script from "./Declare.vue?vue&type=script&lang=js"
export * from "./Declare.vue?vue&type=script&lang=js"
import style0 from "./Declare.vue?vue&type=style&index=0&id=e384f1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384f1be",
  null
  
)

export default component.exports